import { useCallback, useState } from 'react';

import { RadioGroupHookParams, RadioGroupProps } from './types';
import { getSelectedItem } from './utils';

export const useRadioGroup = <ItemID = string>({
  items,
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  onChange = () => {},
  value: initialValue,
  ...rest
}: RadioGroupHookParams<ItemID>): RadioGroupProps<ItemID> => {
  const [value, setValue] = useState(initialValue ?? items[0]?.id);

  const onRadioGroupChange: NonNullable<RadioGroupProps['onChange']> =
    useCallback(
      (_event, value) => {
        const selectedItem = getSelectedItem(items, value);

        setValue(selectedItem.id);

        onChange(selectedItem);
      },
      [onChange, items],
    );

  return { ...rest, items, onChange: onRadioGroupChange, value };
};
